"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Field = require("../formField");
const react_rxk_1 = require("react-rxk");
const react_text_mask_1 = require("react-text-mask");
const logic_1 = require("./logic");
const keautils_1 = require("keautils");
const exec_1 = require("../../botones/exec");
class MaskIcon extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.mask = (props) => props.mask;
        this.maskInput = keautils_1.createSelector(this.mask, x => logic_1.textMaskToMaskedInputMask(x));
        this.pipe = keautils_1.createSelector(this.mask, mask => logic_1.pipeFunc(mask));
        this.onChange = (e) => {
            if (this.props.onChange)
                this.props.onChange(e.target.value);
        };
        this.handleKeyPress = async (ev) => {
            if (ev.key == "Enter") {
                await exec_1.execUserFunc(this.props.onEnter);
            }
        };
    }
    render() {
        const _a = this.props, { addon, error, readonly, value, label, loading } = _a, props = __rest(_a, ["addon", "error", "readonly", "value", "label", "loading"]);
        const mask = this.maskInput(this.props);
        const pipe = this.pipe(this.props);
        const input = React.createElement(react_text_mask_1.default, Object.assign({}, props, { onChange: this.onChange, mask: mask, pipe: pipe, className: "form-control", onKeyPress: this.handleKeyPress, value: value || "", disabled: readonly }));
        return (addon ?
            React.createElement("div", { className: "input-group" },
                React.createElement("span", { className: "input-group-addon" }, addon),
                input) : input);
    }
}
class MaskInputNoRx extends React.PureComponent {
    render() {
        return (React.createElement(Field.FormField, { label: this.props.label, error: this.props.error },
            React.createElement(MaskIcon, Object.assign({}, this.props, { placeholder: this.props.loading ? "Cargando..." : this.props.placeholder }))));
    }
}
/**Textbox que dibuja el texto con una mascara */
exports.Mask = react_rxk_1.componentToRx(MaskInputNoRx, undefined, undefined, {
    loading: { loading: true },
    error: { ignore: { observable: true, promise: true } }
});



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/mask/index.js
// module id = 2209
// module chunks = 0